import { ChangeDetectionStrategy, Component, computed, inject, Input, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ImportantNoticeApi } from '@reconcept-platform/shared/data-access';
import { type ImportantNotice } from '@reconcept-platform/shared/types';
import { ModalWindowController } from '@reconcept-platform/shared/ui/core/modal';
import { ButtonComponent, ButtonContainerComponent } from '@reconcept-platform/shared/ui/standalone/button';
import { ModalContentComponent, ModalFooterComponent } from '@reconcept-platform/shared/ui/standalone/modal';

@Component({
  templateUrl: './important-notice-modal.component.html',
  styleUrl: './important-notice-modal.component.scss',
  imports: [TranslatePipe, ButtonComponent, ButtonContainerComponent, ModalFooterComponent, ModalContentComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ImportantNoticeModalComponent {
  @Input() notices: ImportantNotice[];

  currentNoticeId = computed<string>(() => this.notices[this.noticeIndex()].id);
  noticeIndex = signal<number>(0);

  private importantNoticeApi = inject(ImportantNoticeApi);
  private modalWindowCtrl = inject(ModalWindowController);

  nextOrClose() {
    this.importantNoticeApi.markImportantNoticeAsRead(this.currentNoticeId()).subscribe(() => {
      if (this.noticeIndex() === this.notices.length - 1) {
        this.modalWindowCtrl.dismiss();
      } else {
        this.noticeIndex.set(this.noticeIndex() + 1);
      }
    });
  }
}
